/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bin': {
    width: 12,
    height: 15,
    viewBox: '0 0 12 15',
    data: '<path pid="0" d="M1 13.358V4h10v9.358c0 .433-.17.814-.508 1.145-.338.331-.729.497-1.172.497H2.68c-.443 0-.834-.166-1.172-.497-.339-.33-.508-.712-.508-1.145zM12 1.5V3H0V1.5h3L4.012 0h3.976L9 1.5h3z" _fill="#90A4AE" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/bin.js